import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import HlcFooter from "../components/HlcFooter";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar />
      <div
        style={{
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "120px 24px 60px",
        }}
      >
        <h1 style={{ fontSize: "clamp(48px, 8vw, 96px)", fontWeight: 900, color: "#9b1f6c", margin: 0 }}>
          404
        </h1>
        <h2 style={{ fontSize: "clamp(20px, 3vw, 28px)", color: "#35335b", margin: "12px 0" }}>
          Page Not Found
        </h2>
        <p style={{ color: "#666", maxWidth: 480, margin: "0 0 28px" }}>
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <button
          type="button"
          onClick={() => navigate("/")}
          style={{
            background: "#9b1f6c",
            color: "#fff",
            border: "none",
            padding: "12px 28px",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Back to Home
        </button>
      </div>
      <HlcFooter />
    </>
  );
};

export default NotFound;
